import React, { useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { SidebarContext } from './SidebarContext';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BottomNav } from './BottomNav';
import { ArrowLeft } from 'lucide-react';

const ImpersonateBanner = () => {
  const navigate = useNavigate();
  const backupToken = localStorage.getItem('admin_backup_token');
  const backupUser = localStorage.getItem('admin_backup_user');
  
  if (!backupToken || !backupUser) return null;
  
  const returnToAdmin = () => {
    try {
      const user = JSON.parse(backupUser);
      useAuthStore.setState({
        token: backupToken,
        user: user,
        isAuthenticated: true,
        isSuspended: false,
        isTrialExpired: false,
      });
      localStorage.removeItem('admin_backup_token');
      localStorage.removeItem('admin_backup_user');
      navigate('/admin/companies');
    } catch {
      localStorage.removeItem('admin_backup_token');
      localStorage.removeItem('admin_backup_user');
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-orange-500 text-white text-center py-1.5 text-sm font-medium flex items-center justify-center gap-2" data-testid="impersonate-banner">
      <span>Firma hesabını görüntülüyorsunuz</span>
      <button onClick={returnToAdmin} className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded px-2.5 py-0.5 text-xs font-semibold transition-colors" data-testid="return-to-admin-btn">
        <ArrowLeft className="h-3 w-3" />Admin Panele Dön
      </button>
    </div>
  );
};

export const MainLayout = ({ title = 'Dashboard' }) => {
  const { isAuthenticated } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const hasBackup = !!localStorage.getItem('admin_backup_token');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
      <div className={`min-h-screen bg-background ${hasBackup ? 'pt-8' : ''}`}>
        <ImpersonateBanner />
        <Sidebar />
        <div className="lg:pl-64">
          <Topbar title={title} />
          <main className="p-3 pb-20 sm:p-4 sm:pb-20 md:p-6 lg:pb-6">
            <Outlet />
          </main>
        </div>
        <BottomNav />
      </div>
    </SidebarContext.Provider>
  );
};

export { Sidebar } from './Sidebar';
export { Topbar } from './Topbar';
export { BottomNav } from './BottomNav';
